'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "style"];
import * as React from 'react';
import { useRenderElement } from '@mui/x-scheduler-internals/base-ui-copy';
export const TimelineGridCell = /*#__PURE__*/React.forwardRef(function TimelineGridCell(componentProps, forwardedRef) {
  const elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);

  // TODO: Add aria-colindex using Composite.
  return useRenderElement('div', componentProps, {
    ref: [forwardedRef],
    props: [elementProps, {
      role: 'cell'
    }]
  });
});
if (process.env.NODE_ENV !== "production") TimelineGridCell.displayName = "TimelineGridCell";